import { useCallback } from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
export const viewerCountState = atom({
    key: 'viewerCountState',
    default: {},
});
export function useViewerCount(streamId) {
    const counts = useRecoilValue(viewerCountState) || {};
    if (!streamId) {
        return 0;
    }
    return counts[streamId] || 0;
}
export function useSetViewerCountCallback() {
    const setViewerCount = useSetRecoilState(viewerCountState);
    return useCallback((streamId, value) => {
        if (value > 0) {
            setViewerCount((counts) => ({
                ...counts,
                [streamId]: value,
            }));
            return;
        }
        setViewerCount(({ [streamId]: _, ...counts }) => counts);
    }, [setViewerCount]);
}
